const rootUrl = process.env.REACT_APP_API_ROOT;
const loggerUrl = process.env.REACT_APP_API_LOGGER_LEVEL;

//Nota: la nomenclatura de los nombres esta basado en la salida y entradas de un Aeropuerto.
//Mantener dicha nomenclatura para evitar confusiones.
const Bridge = {
    SaveOne: `${rootUrl}/api/Data/GetStOne`,
    SaveTwo: `${rootUrl}/api/Data/GetStTwo`,
    SaveThree: `${rootUrl}/api/Data/GetStThree`,
    SaveFour: `${rootUrl}/api/Data/GetStFour`,
    SeedProvincia: `${rootUrl}/api/Opciones/provincia`,
    SeedMunicipio: `${rootUrl}/api/Opciones/municipio`,
    SeedPais: `${rootUrl}/api/Opciones/pais`,
    SeedNac: `${rootUrl}/api/Opciones/nacionalidad`,
    GetWA: `${rootUrl}/api/FetchStep/GetWA`,
    GetWB: `${rootUrl}/api/FetchStep/GetWB`,
    GetWC: `${rootUrl}/api/FetchStep/GetWC`,
    GetWD: `${rootUrl}/api/FetchStep/GetWD`,


    //Logs
    SendLogs: `${loggerUrl}`,
    
};

export const { SaveOne, SeedProvincia, SeedMunicipio, SeedPais, GetWA
              , SeedNac, SaveTwo, GetWB
              , GetWC , SaveThree
              , GetWD , SaveFour, SendLogs } = Bridge;